if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.submitButton.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        } else {
          const fallbackSpinner = this.querySelector('.loading__spinner');
          if (fallbackSpinner) fallbackSpinner.classList.remove('hidden');
        }

        const mainProductForm = this.form;
        const mainProductIdElement = mainProductForm.querySelector('[name=id]');
        if (!mainProductIdElement) {
          console.error('Main product ID element not found in form.');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          const loadingSpinner = this.submitButton.querySelector('.loading__spinner');
          if (loadingSpinner) {
            loadingSpinner.classList.add('hidden');
          } else {
            const fallbackSpinner = this.querySelector('.loading__spinner');
            if (fallbackSpinner) fallbackSpinner.classList.add('hidden');
          }
          this.handleErrorMessage('Could not find product variant.');
          return;
        }
        const mainProductId = mainProductIdElement.value;
        const mainProductQuantityInput = mainProductForm.querySelector('[name=quantity]');
        const mainProductQuantity = mainProductQuantityInput ? parseInt(mainProductQuantityInput.value, 10) : 1;

        // Collect properties from the main product form
        const properties = {};
        const propertyInputs = mainProductForm.querySelectorAll('[name^="properties["]');
        propertyInputs.forEach(input => {
          if (input.value.trim() !== '') {
            const propertyName = input.name.match(/properties\[(.+)\]/)[1];
            properties[propertyName] = input.value;
          }
        });

        let items = [{
          id: mainProductId,
          quantity: mainProductQuantity,
          properties: Object.keys(properties).length > 0 ? properties : undefined
        }];

        // Collect accessory items from elements with class '_hid_checkbox' (for single variant accessories)
        const accessoryCheckboxes = document.querySelectorAll('._hid_checkbox:checked');
        accessoryCheckboxes.forEach(checkbox => {
          items.push({
            id: checkbox.value,
            quantity: 1 // Assuming quantity 1 for accessories
          });
        });

        // Collect accessory items from elements with class '_input_selectBox' (for multi-variant accessories)
        const accessorySelects = document.querySelectorAll('._input_selectBox');
        accessorySelects.forEach(select => {
          if (select.value && select.value !== '-1') { // Ensure a valid option is selected
            items.push({
              id: select.value,
              quantity: 1 // Assuming quantity 1 for accessories
            });
          }
        });
        
        // Ensure all items are unique by ID, main product takes precedence if duplicated.
        const uniqueItems = [];
        const seenIds = new Set();
        for (const item of items) {
            if (item.id && !seenIds.has(item.id)) { // Ensure item.id is valid
                uniqueItems.push(item);
                seenIds.add(item.id);
            }
        }
        items = uniqueItems;

        const requestBody = {
          items: items,
        };

        if (this.cart) {
          requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
          requestBody.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        
        const config = fetchConfig('javascript'); // Get base fetch configuration
        config.headers['Content-Type'] = 'application/json'; // Set Content-Type for JSON payload
        config.body = JSON.stringify(requestBody);
        // The original code might have deleted 'Content-Type' for FormData; we explicitly set it now.

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainProductId, // Use main product ID for general error context
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return; // submitButton might not be in the DOM anymore if quick-add modal closed fast
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButton.querySelector('span')) this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainProductId, // Use main product ID for general update context
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.cart) this.cart.renderContents(response);
                  }, 0); 
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart) this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // Ensure submitButton and spinner are still accessible, e.g. if quick add modal closes and removes elements
            const submitButton = this.querySelector('[type="submit"]');

            if (submitButton) {
                submitButton.classList.remove('loading');
                 if (!this.error) submitButton.removeAttribute('aria-disabled');
                 const loadingSpinner = submitButton.querySelector('.loading__spinner');
                 if (loadingSpinner) {
                   loadingSpinner.classList.add('hidden');
                 } else {
                   const fallbackSpinner = this.querySelector('.loading__spinner');
                   if (fallbackSpinner) fallbackSpinner.classList.add('hidden');
                 }
            } else {
                const spinner = this.querySelector('.loading__spinner');
                if (spinner) spinner.classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
